import { z } from "zod";

export const specialRateSchema = z.object({
  rates: z.array(
    z.object({
      itemRateId: z.string().optional()?.default(""),
      itemId: z.string().uuid({
        message: "Required",
      }),
      defaultRate: z.coerce.number().min(1, {
        message: "Required",
      }),
      currentRate: z.coerce.number().optional(),
      specialRate: z.coerce.number().min(1, {
        message: "Required",
      }),
    }),
  ),
  deleteRateIds: z.array(z.string()).optional(),
});

export const emptySpecialRate = [
  {
    itemId: "",
    defaultRate: 0,
    currentRate: 0,
    specialRate: 0,
    itemRateId: "",
  },
];

export type SpecialRate = z.infer<typeof specialRateSchema>;
